import { doProductMobx } from 'restaurant'

const barrageTimers: {
  [key: string]: {
    node: HTMLDivElement;
    cnt: number;
  };
} = {}

class BarrageController {
  static menuWrapper: HTMLBodyElement
  static screenWith: number = document.body.clientWidth

  static createBarrageDom (text: string, imgTitleUrl: string, cnt: number) {
    const key = `${text}_${imgTitleUrl}`
    const img = imgTitleUrl ? `<img src='${imgTitleUrl}' style='width: 20px; height: 20px' />` : ''
    if (barrageTimers[key]) {
      barrageTimers[key].cnt = cnt
      barrageTimers[key].node.innerHTML = `${img}${text} X${barrageTimers[key].cnt}`
      return barrageTimers[key].node
    } else {
      let barrageDom = document.createElement('div')
      const initTop = Math.floor(Math.random() * 352)

      if (!this.menuWrapper) {
        this.menuWrapper = document.querySelector('body')
      }

      barrageDom.classList.add('common-barrage')
      barrageDom.innerHTML = `${img}${text}`
      barrageDom.style.top = `${initTop}px`
      barrageDom.style.display = 'flex'
      barrageDom.style.alignItems = 'center'

      barrageTimers[key] = {
        node: barrageDom,
        cnt: doProductMobx.doProduct.cnt,
      }
      this.menuWrapper && this.menuWrapper.appendChild(barrageDom)
      return barrageDom
    }
  }

  static show (text: string, imgTitle: string, cnt: number) {
    const barrageDom = this.createBarrageDom(text, imgTitle, cnt)
    setTimeout(() => {
      barrageDom.classList.add('show')
    }, 400)
    // 销毁弹幕
    setTimeout(() => {
      barrageDom.remove()
      delete barrageTimers[text]
    }, 10420)
  }
}

export default BarrageController
